module.exports = require("core-js-pure/features/parse-int");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/parse-int.js
// module id = 493
// module chunks = 13